import { LockIcon } from '@/assets';
import { BackdropImage } from '@/components/ui/backdropImage';
import { Button } from '@/components/ui/button';
import { CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { routes } from '@/types/routes';
import { createFileRoute, Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

export const Route = createFileRoute(
  '/_auth/(forgot-password)/password-updated',
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { t } = useTranslation();

  return (
    <>
      <CardHeader className="gap-space-2xs">
        <CardTitle className="text-heading-lg-semibold">
          { t('forgotPassword.passwordUpdated.title', { ns: 'auth' }) }
        </CardTitle>
        <CardDescription className="text-body-md-normal">
          { t('forgotPassword.passwordUpdated.description', { ns: 'auth' }) }
        </CardDescription>
      </CardHeader>

      <CardContent className="pt-space-lg flex flex-col items-center">
        <BackdropImage src={ LockIcon } className="mb-space-md" />

        <div className="grid gap-space-2xs w-full pt-space-md">
          <Link to={ routes.login } className="w-full text-center">
            <Button className="w-full">
              { t('buttons.signIn', { ns: 'auth' }) }
            </Button>
          </Link>
        </div>
      </CardContent>
    </>
  );
}
